import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

export const BreadcrumbsSeparatorIcon = () => {
    return <MuiIcon icon={'keyboard_arrow_right'} fontSize={'2.2rem'} color={'var(--text-quaternary)'} />;
};
